/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'

import { authAddAdmin, authRemoveAdmin, authViewAdmin } from 'services'
import { AdminFormModal } from 'features'

import MainLayout from 'components/layouts/main'
import { notifySuccess, notifyError } from 'components/commons/toast'

import { ToastContainer } from 'react-toastify'
import { responseMessage } from 'constant'
import Button from 'components/commons/button'

const AdminSettingsPage = () => {
  const [adminForm, setAdminForm] = useState(false)
  const [adminRole, setAdminRole] = useState(false)

  const closeModal = (modal: string) => {
    if (modal === 'admin-role-modal') {
      setAdminForm(false)
    }
  }

  const viewAdmins = async () => {
    await authViewAdmin()
  }

  const saveNewAdmin = async (newAdminEmail: string, adminRoleSelected: boolean) => {
    if (newAdminEmail) {
      if (adminRoleSelected) {
        // add admin
        closeModal('admin-role-modal')
        notifySuccess('Adding Admin...')
        await authAddAdmin(newAdminEmail)

        setTimeout(() => {
          notifySuccess('Check Current Admins to View Updated List')
        }, 1500)
      } else {
        // remove admin
        closeModal('admin-role-modal')
        notifySuccess('Removing Admin...')
        await authRemoveAdmin(newAdminEmail)

        setTimeout(() => {
          notifySuccess('Check Updated Admins in View Current Admins')
        }, 1500)
      }
    }
  }

  const openAdminForm = (selectedAdminRole: boolean) => {
    setAdminRole(selectedAdminRole)
    setAdminForm(true)
  }

  return (
    <React.Fragment>
      <MainLayout>
        <h1 className='font-bold text-4xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
          Admin Settings Page
        </h1>

        <div style={{ display: 'flex', flex: 'row', justifyContent: 'center' }}>
          {/* <Button
            onClick={() => authViewAdmin()}
            className='bg-black-500 font-semibold text-white capitalize'
            style={{ width: 250, marginRight: 24, color: '3A3B3C', backgroundColor: '#3A3B3C' }}
            disable='true'
          >
            View Current Admins
  </Button>*/}

          <Button
            onClick={() => openAdminForm(true)}
            className='bg-blue-500 font-semibold text-white capitalize'
            style={{ width: 250, marginRight: 24 }}
          >
            Add Admin
          </Button>

          <Button
            onClick={() => openAdminForm(false)}
            className='bg-red-500 font-semibold text-white capitalize'
            style={{ width: 250 }}
          >
            Remove Admin
          </Button>
        </div>

        {adminForm && (
          <AdminFormModal
            adminRoleChange={adminRole}
            onSubmit={saveNewAdmin}
            onClose={closeModal}
          />
        )}

        <ToastContainer limit={1} autoClose={3000} />
      </MainLayout>
    </React.Fragment>
  )
}

export default AdminSettingsPage
